import { useTranslation } from 'react-i18next';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { Input, TextArea } from 'shared/components/FormControl';
import { FONT_SIZES, SPACINGS } from 'shared/styles/variables';
import styled from 'styled-components';

import ThemeEditorFormActionFooter, {
  ACTION_FOOTER_HEIGHT,
} from 'dashboard/components/ThemeEditorFormActionFooter';
import { FORM_THEME_EDITOR_DOCUMENTS_UPLOAD_PAGE_NAME } from 'dashboard/lib/constants/formNames';
import { COLORS } from 'dashboard/styles/variables';

const Title = styled('h2')`
  color: ${COLORS.black};

  padding-top: ${SPACINGS.base * 5}px;
  padding-left: ${SPACINGS.base * 2}px;
  padding-bottom: ${SPACINGS.base * 3}px;
  border-bottom: 1px solid ${COLORS.gray20};
`;
const Section = styled('div')`
  padding: ${SPACINGS.base * 2}px;
  margin-bottom: ${ACTION_FOOTER_HEIGHT};
`;
const StyledLabel = styled('label')`
  display: inline-block;
`;
const Hint = styled('p')`
  font-size: ${FONT_SIZES.small};
  color: ${COLORS.gray50};
  margin-bottom: ${SPACINGS.base}px;
`;
const StyledField = styled(Field)<any>`
  margin-bottom: ${SPACINGS.base * 3}px;
`;

interface FormThemeEditorDocumentsUploadPageProps {}

const FormThemeEditorDocumentsUploadPage = (
  props: FormThemeEditorDocumentsUploadPageProps & InjectedFormProps,
) => {
  const [t] = useTranslation();
  return (
    <form onSubmit={props.handleSubmit}>
      <Title>Documents Upload Page</Title>
      <Section>
        <StyledLabel htmlFor='document-upload-theme-form__title-input'>Title</StyledLabel>
        <Hint>Title for start page (only displayed if no logo)</Hint>
        <StyledField
          type='text'
          id='document-upload-theme-form__title-input'
          placeholder={t('documents.intro.title')}
          name='template.documents-config.intro-screen.title'
          component={Input}
        />

        <StyledLabel htmlFor='document-upload-theme-form__body-input'>Body</StyledLabel>
        <Hint>Body for start page</Hint>
        <StyledField
          id='document-upload-theme-form__body-input'
          name='template.documents-config.intro-screen.prompt'
          component={TextArea}
          placeholder={t('documents.intro.prompt')}
        />
      </Section>

      <ThemeEditorFormActionFooter
        dataTestBlock='form-theme-editor-documents-upload-page'
        handleUndo={props.reset}
        submitting={props.submitting}
        pristine={props.pristine}
      />
    </form>
  );
};

export default reduxForm<{}, FormThemeEditorDocumentsUploadPageProps>({
  form: FORM_THEME_EDITOR_DOCUMENTS_UPLOAD_PAGE_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(FormThemeEditorDocumentsUploadPage);
